import { SignInPopup } from '@frontend/features/authentication'
import CookieConsentPopup from '@frontend/features/cookie-consent-popup/CookieConsentPopup'
import SubscriptionPopup from '@frontend/features/fluent-form/subscription-popup/SubscriptionPopup'
import useProductListStore from '@frontend/features/product-list/libs/useProductListStore'
import QuickView from '@frontend/features/products/components/quick-view/QuickView'
import SearchBar from '@frontend/features/search-bar/SearchBar'
import MiniCart from '@frontend/features/shop/cart/MiniCart'
import { useGlobalStore } from '@frontend/libs/stores/globalStore'
import { useCartStore } from '@frontend/libs/stores/useCartStore'
import { useProductStore } from '@frontend/libs/stores/useProductStore'
import { useSearchStore } from '@frontend/libs/stores/useSearchStore'
import { PopupEvent } from '@scripts/frontend/features/popup-event/PopupEvent'
import ErrorBoundary from '@shared/ErrorBoundary'
import { useLayoutEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'

import Footer from '../partials/footer/Footer'
import Header from '../partials/header/Header'

export function DefaultTemplate() {
  const location = useLocation()

  const { setLoginPopupOpen } = useGlobalStore((state) => state)
  const { closeQuickView, setVariation } = useProductStore((state) => state)
  const { closeMiniCart } = useCartStore((state) => state)
  const { closeModal } = useSearchStore((state) => state)
  const { init } = useProductListStore((state) => state)

  // Clear up on component unmount
  useLayoutEffect(() => {
    return () => {
      closeModal()
      closeMiniCart()
      closeQuickView()
      setVariation(null)
      setLoginPopupOpen(false)
      init()
    }
  }, [
    closeMiniCart,
    closeModal,
    closeQuickView,
    init,
    location,
    setLoginPopupOpen,
    setVariation,
  ])

  // Scroll to top of page after a page transition.
  useLayoutEffect(() => {
    document.documentElement.scrollTo({ behavior: 'instant', left: 0, top: 0 })
  }, [location.pathname])
  return (
    <ErrorBoundary>
      <Header />
      <main className="container bg-white" id="main">
        <Outlet />
      </main>
      <Footer />
      <MiniCart />
      <QuickView />
      <SearchBar />
      <CookieConsentPopup />
      <SignInPopup />
      <PopupEvent />
      <SubscriptionPopup />
    </ErrorBoundary>
  )
}

export default DefaultTemplate
